import { formatToCompanyTimezone, formatToUtc, getDateTimeFromSelectedDate, getYearFromCompanyDate } from "../lib/functions";
import dayjs from "dayjs";
import Big from "big.js";

// Discount for a single item row: reads whichever mode is active
// (percent, the default/undefined-safe mode, or a flat amount), clamped
// so a flat amount can never exceed the item's own line total.
const getItemDiscountAmount = (item, line) => {
  if (item?.discountMode === "amount") {
    const raw = new Big(item?.discountAmt || 0);
    return raw.gt(line) ? line : raw.lt(0) ? new Big(0) : raw;
  }
  return line.times(item?.discount || 0).div(100);
};

export const createServiceExpensePayload = (state, authInfo) => {
  const {
    supplierInfo,
    itemCart,
    footerValues,
    narration,
    voucherNumber,
    service_ex_id,
    entryDate,
    paymentTerm,
    tagFieldId,
    conversion_rate,
    conversion_currency,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc,
    taxMode,
    payServiceCart,
    selectedServiceExpenseAcc,
    tag_field_id
  } = state;

  // convert selected/entry Date to utc date + time
  let finalEntryDate = entryDate;
  if (!dayjs(entryDate).isSame(dayjs(), "day")) {
    finalEntryDate = getDateTimeFromSelectedDate(entryDate); // Merge date + current time in TZ

  } else {
    finalEntryDate = entryDate; // Use now in TZ
  }
  let dateUTC = formatToUtc(finalEntryDate)
  let companydate = formatToCompanyTimezone(dateUTC);
  const vchYear = getYearFromCompanyDate(companydate);

  const payload = {
    service_ex_id: service_ex_id || 0,
    service_ex_voucher_no: voucherNumber,
    is_cal_type: taxMode === "on_total" ? "on_total" : "individual",
    vchdate: vchYear,

    itemCart: itemCart.map((it) => {
      const quantity = Big(it.quantity || 0);
      const rate = Big(it.rate || 0);
      const taxPct = Big(it.tax_per || 0);
      const baseAmount = quantity.times(rate);
      const isOnTotal = taxMode === "on_total";

      const discountAmount = getItemDiscountAmount(it, baseAmount);
      // Back-computed so item_discount_per stays meaningful (e.g. for
      // printed vouchers) even when the row is in flat-amount mode.
      const discountPct = it.discountMode === "amount"
        ? (baseAmount.eq(0) ? 0 : Number(discountAmount.div(baseAmount).times(100).toFixed(13)))
        : Big(it.discount || 0);
      const discounted = baseAmount.minus(discountAmount);
      const taxAmount = discounted.times(taxPct).div(100);
      const total = discounted.plus(taxAmount);

      return {
        warehouse_id: it.warehouse_id || 0,
        warehouse_name: it.warehouse_name || "",
        item_id: it.item_id,
        item_name: it.product,
        display_text: `${it.display_text || ""}${it.item_code || ""}`,
        item_qty: quantity.toString(),
        service_ex_qty: quantity.toString(),
        item_rate: rate.toString(),
        service_ex_rate: rate.toString(),

        // ✅ Conditional item-level discount & tax
        item_discount: isOnTotal ? 0 : discountAmount.toString(),
        item_discount_per: isOnTotal ? 0 : discountPct,
        discount_mode: it.discountMode === "amount" ? "amount" : "percent",
        discount_acc_id: selectedDiscountAcc?.acc_id || 0,
        discount_acc_name: selectedDiscountAcc?.acc_name || "",

        item_tax: isOnTotal ? "0" : taxAmount.toString(),
        item_tax_per: isOnTotal ? "0" : taxPct.toString(),
        tax_acc_id: selectedTaxAcc?.acc_id || 0,
        tax_acc_name: selectedTaxAcc?.acc_name || "",

        item_total: isOnTotal
          ? baseAmount.toString()
          : total.toString(),

        qty_display: `${quantity} ${it.unit_symbol || ""}`,
        unit_name: it.unit_name || "",
        unit_symbol: it.unit_symbol || "",
        base_unit_name: it.base_unit_name || null,
        per_unit_id: it.per_unit_id || null,
        per_unit_symbol: it.per_unit_symbol || null,
        conversion: it.conversion || 1,
        per_conversion: it.per_conversion || 1,
        retail_qty: it.retail_qty || 0,
        is_serial: it.is_serial || "no",
        serials: it.serials || [],
        units: it.units || [],
      };
    }),



    // itemCart: itemCart.map((it) => ({
    //   warehouse_id: it.warehouse_id || 0,
    //   warehouse_name: it.warehouse_name || "",
    //   item_id: it.item_id,
    //   item_name: it.product,
    //   display_text: `${it.display_text ? it.display_text : ""}${it.item_code ? it.item_code : ""}`,
    //   item_qty: String(it.quantity),
    //   service_ex_qty: it.quantity,
    //   item_rate: String(it.rate),
    //   service_ex_rate: it.rate,
    //   item_discount: 0,
    //   item_discount_per: it.discount || 0,
    //   discount_acc_id: selectedDiscountAcc?.acc_id || 0,
    //   discount_acc_name: selectedDiscountAcc?.acc_name || "",
    //   item_tax: String((
    //     ((Number(it.quantity) * Number(it.rate)) -
    //       ((it.discount || 0) / 100) * (Number(it.quantity) * Number(it.rate))) *
    //     (Number(it.tax_per) || 0)) / 100),
    //   item_tax_per: String(it.tax_per || 0),
    //   tax_acc_id: selectedTaxAcc?.acc_id || 0,
    //   tax_acc_name: selectedTaxAcc?.acc_name || "",
    //   item_total: ((Number(it.quantity) * Number(it.rate)) +
    //     ((((Number(it.quantity) * Number(it.rate)) -
    //       ((it.discount || 0) / 100) * (Number(it.quantity) * Number(it.rate))) *
    //       (Number(it.tax_per) || 0)) / 100)).toFixed(2),
    //   qty_display: `${it.quantity} ${it.unit_symbol || ""}`,
    //   unit_name: it.unit_name || "",
    //   unit_symbol: it.unit_symbol || "",
    //   base_unit_name: it.base_unit_name || null,
    //   per_unit_id: it.per_unit_id || null,
    //   per_unit_symbol: it.per_unit_symbol || null,
    //   conversion: it.conversion || 1,
    //   per_conversion: it.per_conversion || 1,
    //   retail_qty: it.retail_qty || 0,
    //   is_serial: it.is_serial || "no",
    //   serials: it.serials || [],
    //   units: it.units || [],
    // })),

    masterData: {
      service_ex_voucher_no: voucherNumber,
      is_serial: "no",
      is_cal_type: taxMode === "on_total" ? "on_total" : "individual",
      created_date: entryDate
        ? formatToUtc(finalEntryDate)
        : null,
      narration: narration || footerValues.description || "",
      sub_total: footerValues.subtotal,

      total_transport_cost: footerValues.total_transport_cost,
     total_amount: (
    parseFloat(footerValues.subtotal || 0) -
    parseFloat(footerValues.total_discount || 0) +
    parseFloat(footerValues.totalTax || 0)
  ).toFixed(2),
      paid_amount: footerValues.paidAmount || 0,
      due_amount: footerValues.dueAmount || 0,
      discount_acc_id: selectedDiscountAcc?.acc_id || 0,
      tax_acc_id: selectedTaxAcc?.acc_id || 0,
      transport_acc_id: selectedTransportAcc?.acc_id || 0,
      service_ex_acc_id: selectedServiceExpenseAcc?.acc_id || 0,
      conversion_rate,
      conversion_currency,
      ...(taxMode === "on_total"
        ? {
          total_discount_per: footerValues.discountPct || 0,
          total_discount: parseFloat(footerValues.total_discount || 0),
          total_discount_mode: footerValues?.discountMode === "amount" ? "amount" : "percent",
          total_tax_per: footerValues.taxPct || 0,
          total_tax: parseFloat(footerValues.totalTax || 0),
        }
        : {
          total_discount_per: 0,
          total_discount: parseFloat(footerValues.total_discount || 0),
          total_discount_mode: "percent",
          total_tax_per: 0,
          total_tax: parseFloat(footerValues.totalTax || 0),
        }),
      ...(tag_field_id && tag_field_id.length > 0
        ? {
          tag_field_id: tag_field_id,
        }
        : {}),
    },

    orderId: footerValues.order_id || 0,

    supplier: {
      acc_id: supplierInfo?.acc_id,
      acc_name: supplierInfo?.acc_name,
      institution_name: supplierInfo?.institution_name,
      address: supplierInfo?.address,
      contact_no: supplierInfo?.contact_no,
    },

    // sub_total: footerValues.subtotal,
    // total_discount: footerValues.total_discount,
    // total_discount_per: footerValues.discountPct,
    // total_tax: footerValues.totalTax,
    // total_tax_per: footerValues.taxPct || authInfo?.item_tax || 0,
    // total_transport_cost: footerValues.total_transport_cost,
    // service_charge: footerValues.serviceCharge,
    // total_amount: footerValues.grandTotal,


    // discount_acc_id: selectedDiscountAcc?.acc_id || 0,
    // tax_acc_id: selectedTaxAcc?.acc_id || 0,
    // transport_acc_id: selectedTransportAcc?.acc_id || 0,

    // narration: narration || "",
    // tag_field_id: tagFieldId,
    // conversion_rate,
    // conversion_currency,
    // other_service_cost: 0,

    payCart: (payServiceCart || []).map((p) => ({
      from_acc_id: p.to_acc_id || 0,
      from_acc_name: p.to_acc_name || "",
      tran_amount: String(p.amount || p.tran_amount || 0),
    })),
  };
  if (footerValues.service_ex_o_id) {
    payload.service_ex_o_id = footerValues.service_ex_o_id;
  }

  // if (taxMode != "on_total") {
  //   payload.masterData.total_discount_per = 0;
  //   payload.masterData.total_discount = 0;
  //   payload.masterData.total_tax_per = 0;
  //   payload.masterData.total_tax = 0;
  // }
  return payload;
};
